// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._18s8ze3t{margin:var(--ds-space-0,0)}
._1yt4ze3t{padding:var(--ds-space-0,0)}
._18zr12x7{padding-inline:var(--ds-space-075,6px)}
._1pfhze3t{margin-block-start:var(--ds-space-0,0)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/pagination/dist/esm/pagination.compiled.css"],"names":[],"mappings":"AAAA,WAAW,0BAA0B;AACrC,WAAW,2BAA2B;AACtC,WAAW,sCAAsC;AACjD,WAAW,sCAAsC","sourcesContent":["._18s8ze3t{margin:var(--ds-space-0,0)}\n._1yt4ze3t{padding:var(--ds-space-0,0)}\n._18zr12x7{padding-inline:var(--ds-space-075,6px)}\n._1pfhze3t{margin-block-start:var(--ds-space-0,0)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
